<template>
  <div ref="content" class="content">
    <ul class="toolBar-container">
      <li @click="type = 'myTool'" :class="{on: type === 'myTool'}">我的工具</li>
      <li
        @click="type = 'analysis'"
        v-if="$store.state.has_sentiment"
        :class="{on: type === 'analysis', new: cardList.client.has_new || cardList.themeTrack.has_new || cardList.mediaBoard.has_new}"
      >舆情分析</li>
      <li
        @click="type = 'statistic'"
        v-if="$store.state.has_datacenter"
        :class="{on: type === 'statistic', new: cardList.knewsdata.has_new || cardList.tvbaopian.has_new || cardList.spread.has_new || cardList.track.has_new}"
      >数据中心</li>
    </ul>
    <div
      v-if="type === 'myTool'"
      ref="tabList"
      :style="'height:'+twoHeight"
      :class="{'tab-list': true,hide: !showAllBox}"
    >
      <div
        @mouseenter="cleanInterval"
        @mouseleave="startInterval"
        class="tab"
        :style="`height: ${boxHeight}px`"
      >
        <div class="title-container">
          <p class="title bold">公告</p>
          <div class="arrow-container">
            <p @click="leftArrowClick" :class="{leftArrow: true,on: latestNoticesIndex > 0}"></p>
            <p
              @click="rightArrowClick"
              :class="{rightArrow: true,on: latestNoticesIndex < cardList.latestNotices.list.length - 1}"
            ></p>
          </div>
        </div>
        <div class="wordContent">
          <ul
            :style="`transform: translateX(-${latestNoticesIndex * 100}%);transition: 0.5s linear`"
          >
            <li
              @click="goAnnouce(item)"
              :title="item.title"
              class="overflow2"
              v-for="(item,index) in cardList.latestNotices.list"
              :key="index"
            >{{item.title}}</li>
          </ul>
        </div>
      </div>
      <!--  -->
      <div ref="tings" class="tab todos" :style="`height: ${boxHeight}px`">
        <div class="title-container">
          <p class="title bold">待处理</p>
          <div class="arrow-container">
            <p @click="dealLeft" :class="{leftArrow: true,on: dealIndex > 0}"></p>
            <p
              @click="dealRight"
              :class="{rightArrow: true,on: dealIndex < Math.abs(Math.ceil((dealList.length / 3)-1))}"
            ></p>
          </div>
        </div>
        <div ref="tingsContent" class="tingsContent">
          <ul
            :style="`transform: translateX(-${dealIndex * thingWidth * 3}px);transition: 0.5s linear`"
          >
            <li
              @click="goDynamicRoute(item)"
              v-for="(item, index) in todos"
              :key="index"
              v-show="item.able"
              :class="{on: index === Number(dealIndex) * 3 + 2}"
              :style="`min-width: ${thingWidth}px;min-height: ${thingHeight}px;`"
            >
              <p :class="{num: true, grey: item.count == 0}">{{item.count}}</p>
              <p>{{item.title}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-show="cardList.ai_wisdom_strategy.is_show"
        @click="navigateToOut(cardList.ai_wisdom_strategy.redirect_url);"
        :class="{tab: true, common: true, new: true}"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>AI智策</span>
            <p>洞察全网热点，智启创作灵感</p>
          </div>
          <div class="right-container">
            <p class="aiWisdomStrategy"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.aigcEdit.is_show"
        class="tab common new"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateToOut(cardList.aigcEdit.redirect_url);" class="useTab">
          <div class="left-container">
            <span>Scube智媒魔方</span>
            <p>AI创意制作文稿&nbsp;&nbsp; 剪辑视频</p>
          </div>
          <div class="right-container">
            <p class="aigc"></p>
          </div>
        </div>
      </div>
      <div
        @click="goCloudEdit()"
        v-show="cardList.bsEdit.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>视频剪辑</span>
            <p>实时在线剪辑原创视频</p>
          </div>
          <div class="right-container">
            <p class="videoEdit"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.meiZi.is_show"
        @click="navigateToMZ"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>媒资网</span>
            <p>媒资库检索更专业的素材</p>
          </div>
          <div class="right-container">
            <p class="mzCallback"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.xwmzRedirect.is_show"
        @click="navigateToOut(cardList.xwmzRedirect.redirect_url);"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>新闻媒资</span>
            <p>一手掌握全量新闻媒资信息</p>
          </div>
          <div class="right-container">
            <p class="mzNews"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.streamMedia.is_show"
        @click="navigateToStream"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>EPM媒资</span>
            <p>海量媒资信息一键回调使用</p>
          </div>
          <div class="right-container">
            <p class="streamMedia"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.seriesSingle.is_show"
        @click="navigateToPublic"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>公共串联单库</span>
            <p>查看公共串联单库</p>
          </div>
          <div class="right-container">
            <p class="chuanLian"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.live.is_show" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>在线直播</span>
            <p>自编播单体验在线云导播</p>
          </div>
          <div class="right-container">
            <p class="cloudLive"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.dataCenter.is_show"
        @click="navigate(cardList.dataCenter.menu_type,cardList.dataCenter.idstring)"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>数据中心</span>
            <p>全面掌握报道数据</p>
          </div>
          <div class="right-container">
            <p class="dataCenter"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.appraisal.is_show"
        @click="navigate(cardList.appraisal.menu_type,cardList.appraisal.idstring)"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>考评打分</span>
            <p>多端稿件使用情况在线打分</p>
          </div>
          <div class="right-container">
            <p class="rank"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.proposal.is_show"
        @click="navigate(cardList.proposal.menu_type,cardList.proposal.idstring)"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>办公提案</span>
            <p>在线提交每周提案</p>
          </div>
          <div class="right-container">
            <p class="proposal"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.anchor.is_show"
        @click="navigateToAnchor"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>虚拟主播</span>
            <p>
              输入文稿 虚拟主播
              播报视频
            </p>
          </div>
          <div class="right-container">
            <p class="anchor"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.videoStudio.is_show"
        @click="navigateToyb"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>演播室管理</span>
            <p>演播室租借信息一手把握</p>
          </div>
          <div class="right-container">
            <p class="video"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.timeVideo.is_show"
        :class="{tab: true, common: true, new: cardList.timeVideo.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('timeVideo')" class="useTab">
          <div class="left-container">
            <span>时移回看</span>
            <p>实时直播 一键回看</p>
          </div>
          <div class="right-container">
            <p class="timeVideo"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.voiceRec.is_show"
        :class="{tab: true, common: true}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('voiceRec')" class="useTab">
          <div class="left-container">
            <span>语音识别</span>
            <p>将语音转换成文字</p>
          </div>
          <div class="right-container">
            <p class="lx"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.voiceEditList.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('voiceEditList')" class="useTab">
          <div class="left-container">
            <span>音频剪辑</span>
            <p>通过文字剪辑音频</p>
          </div>
          <div class="right-container">
            <p class="videoEdit"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.gsportsSubscribeFilter.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navToThird('gsportsSubscribeFilter')" class="useTab">
          <div class="left-container">
            <span>体育订阅筛选</span>
            <p>
              筛选优质的体育互
              联网资讯
            </p>
          </div>
          <div class="right-container">
            <p class="subScribe"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.voiceComposeList.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('voiceComposeList')" class="useTab">
          <div class="left-container">
            <span>语音合成</span>
            <p>将文字转换成音频</p>
          </div>
          <div class="right-container">
            <p class="voiceComposeList"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.intelligentWriting.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('intelligentWriting')" class="useTab">
          <div class="left-container">
            <span>智能写稿(Deepseek)</span>
            <p>对话写作助手</p>
          </div>
          <div class="right-container">
            <p class="intelligentWriting"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.nanometer_consulting.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('nanometer_consulting')" class="useTab">
          <div class="left-container">
            <span>体育资讯上屏</span>
            <p>准点、突发电视资讯包装上屏制作</p>
          </div>
          <div class="right-container">
            <p class="nanometer_consulting"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.gsports_program_series.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('gsports_program_series')" class="useTab">
          <div class="left-container">
            <span>体育串联单</span>
            <p>随时随地，查看体育串联单</p>
          </div>
          <div class="right-container">
            <p class="gsports_program_series"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.newsCascadeMonad.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateToTab(cardList.newsCascadeMonad.redirect_url);" class="useTab">
          <div class="left-container">
            <span>新闻串联单</span>
            <p>查看新闻串联单</p>
          </div>
          <div class="right-container">
            <p class="chuanlian"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.interplay.is_show"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateToOut('/unifiedContentLibrary/content/interplay');" class="useTab">
          <div class="left-container">
            <span>Avid反推</span>
            <p></p>
          </div>
          <div class="right-container">
            <p class="interplay"></p>
          </div>
        </div>
      </div>

      <!-- <div class="fillBox" :style="`width: ${boxWidth}px`"></div> -->
      <div class="fillBox" v-for="(item,index) in fillList" :key="index"></div>
    </div>

    <div v-if="type === 'analysis'" ref="tabList" :class="{'tab-list': true}">
      <div
        v-if="cardList.client.is_show"
        @click="navigateTo('client')"
        :class="{tab: true, common: true, new: cardList.client.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>客户端动态</span>
            <p>实时各平台推送动态资讯</p>
          </div>
          <div class="right-container">
            <p class="client"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.themeTrack.is_show"
        @click="navigateTo('themeTrack')"
        :class="{tab: true, common: true, new: cardList.themeTrack.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>专题追踪</span>
            <p>关键词搜索相关新闻，即时追踪动态</p>
          </div>
          <div class="right-container">
            <p class="zt"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.mediaBoard.is_show"
        @click="navigateTo('media')"
        :class="{tab: true, common: true, new: cardList.mediaBoard.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>媒体看板</span>
            <p>了解媒体最新发布内容</p>
          </div>
          <div class="right-container">
            <p class="media"></p>
          </div>
        </div>
      </div>
      <div
        class="fillBox"
        style="height: 1px;padding: 0;"
        v-for="(item,index) in fillList"
        :key="index"
      ></div>
    </div>

    <div v-if="type === 'statistic'" ref="tabList" :class="{'tab-list': true}">
      <div
        @click="navigate('kankan','kankanshuju')"
        v-if="cardList.knewsdata.is_show"
        :class="{tab: true, common: true, new: cardList.knewsdata.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>看看发布</span>
            <p>全面掌握看看新闻详细数据</p>
          </div>
          <div class="right-container">
            <p class="kankan"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.tvbaopian.is_show"
        :class="{tab: true, common: true, new: cardList.tvbaopian.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigate('tv','tvbaopian')" class="useTab">
          <div class="left-container">
            <span>电视报片</span>
            <p>实时把握电视动态</p>
          </div>
          <div class="right-container">
            <p class="tv"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.spread.is_show"
        :class="{tab: true, common: true, new: cardList.spread.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('analysisList')" class="useTab">
          <div class="left-container">
            <span>内容传播力分析</span>
            <p>关注你关心的内容实时传播力解析</p>
          </div>
          <div class="right-container">
            <p class="mediaContent"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.track.is_show"
        :class="{tab: true, common: true, new: cardList.track.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('contentTrackList')" class="useTab">
          <div class="left-container">
            <span>文稿跟踪</span>
            <p>
              跟踪自定义文稿
              了解传播效果
            </p>
          </div>
          <div class="right-container">
            <p class="article"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.dataCenterPublishCalculate.is_show"
        :class="{tab: true, common: true, new: cardList.dataCenterPublishCalculate.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('dataCenter')" class="useTab">
          <div class="left-container">
            <span>内容发布统计</span>
            <p>掌握平台及个人发布数据</p>
          </div>
          <div class="right-container">
            <p class="dataCenterPublishCalculate"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.drowAnalize.is_show"
        :class="{tab: true, common: true, new: cardList.drowAnalize.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('dataCenter', 1)" class="useTab">
          <div class="left-container">
            <span>用户画像分析</span>
            <p>看看新闻用户画像析数据</p>
          </div>
          <div class="right-container">
            <p class="printIcon"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.productAnalize.is_show"
        :class="{tab: true, common: true, new: cardList.productAnalize.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navigateTo('dataCenter', 2)" class="useTab">
          <div class="left-container">
            <span>产品运营分析</span>
            <p>了解看看新闻移动端运营数据</p>
          </div>
          <div class="right-container">
            <p class="ggIcon"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.gsportsData.is_show"
        :class="{tab: true, common: true, new: cardList.gsportsData.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navToThirdSport('gsportsData')" class="useTab">
          <div class="left-container">
            <span>Gsports数据</span>
            <p>
              掌握平台内容生产
              数据
            </p>
          </div>
          <div class="right-container">
            <p class="gSport"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.fiveViewData.is_show"
        :class="{tab: true, common: true, new: cardList.fiveViewData.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navToThirdSport('fiveViewData')" class="useTab">
          <div class="left-container">
            <span>五星收视数据</span>
            <p>五星电视数据一手掌握</p>
          </div>
          <div class="right-container">
            <p class="wTv"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.gsportsOperateData.is_show"
        :class="{tab: true, common: true, new: cardList.gsportsOperateData.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navToThirdSport('gsportsOperateData')" class="useTab">
          <div class="left-container">
            <span>体育运营数据</span>
            <p>微信电视-新媒体运营数据</p>
          </div>
          <div class="right-container">
            <p class="sportIcon"></p>
          </div>
        </div>
      </div>
      <div
        v-if="cardList.thirdSpread.is_show"
        :class="{tab: true, common: true, new: cardList.thirdSpread.has_new}"
        :style="`height: ${boxHeight}px`"
      >
        <div @click="navToThirdspread('thirdSpread')" class="useTab">
          <div class="left-container on">
            <span>第三方传播影响力</span>
            <p>其他平台传播力影响力数据分析</p>
          </div>
          <div class="right-container">
            <p class="thirdSpread"></p>
          </div>
        </div>
      </div>
      <div
        v-show="cardList.dailyreport.is_show"
        @click="navigateToDailyReport"
        class="tab common"
        :style="`height: ${boxHeight}px`"
      >
        <div class="useTab">
          <div class="left-container">
            <span>数据日报</span>
            <p>掌握每日动态 驱动精准决策</p>
          </div>
          <div class="right-container">
            <p class="dailyreport"></p>
          </div>
        </div>
      </div>
      <div class="fillBox" v-for="(item,index) in fillList" :key="index"></div>
    </div>

    <div v-show="showToggle && type == 'myTool'" class="toggleBtn">
      <div @click="showAllBox = !showAllBox;toggleAll()" class="toggle">
        <span>{{showAllBox ? '收起' : '展开'}}全部功能</span>
        <p :class="{arrow: true,on: showAllBox}"></p>
      </div>
    </div>

    <div :class="{'content-container': true, on: selectListNum > 0}">
      <div class="search-cotnainer">
        <div class="left-container">
          <ul>
            <li
              v-for="(item,index) in tabList"
              :key="index"
              @click="pageType = item.key"
              :class="{on: item.key === pageType,bold:true}"
            >{{item.title}}</li>
          </ul>
        </div>
        <div class="right-container list">
          <globalFilter :pageType="pageType" ref="globalFilter" v-show="showFilter" />
        </div>
      </div>

      <div class="filter-container">
        <div class="filter">
          <div class="filterBtn">
            <span
              @click="filterType = index"
              v-for="(item, index) in filterTypeList"
              :key="index"
              :class="{on: filterType == index}"
            >{{item}}</span>
          </div>
          <date-picker
            v-model="datePicker"
            range
            placeholder="    开始时间    ～    结束时间"
            calendar-icon="none"
            :editable="false"
            :clearable="true"
            :shortcuts="false"
            confirm
          ></date-picker>
        </div>
        <div class="yesterday">
          <img src="@assets/img/index/filter.png" alt />
          <p v-if="pageType=='file'">
            昨日新增素材
            <i>{{yesterdayNum || 0}}</i>
            个
          </p>
          <p v-if="pageType=='material'">
            昨日新增线索
            <i>{{yesterdayNum || 0}}</i>
            个
          </p>
        </div>
      </div>

      <!-- 如果没有权限显示 -->
      <div class="listContent" v-if="!loading">
        <noMore v-if="!show_list"></noMore>
        <empty :mTop="30" v-else-if="empty" :msg="`暂无${empty}`" />
        <materialList
          @setIsSelectAll="setIsSelectAll"
          v-else-if="pageType=='file'"
          class="materialList"
          :mList="mList"
        ></materialList>
        <clueList v-else class="clueList" :clueList="clueList"></clueList>
      </div>
      <skeleton v-show="waiting && pageType=='file'" mediaType="media"></skeleton>
      <skeleton v-show="waiting && pageType=='material'" mediaType="list"></skeleton>
      <pages
        v-if="page.pageIndex>1||!loading"
        :page_count="page.pageCount"
        :index="page.pageIndex"
        :total="page.total"
      ></pages>
    </div>
    <div
      v-show="selectListNum > 0"
      :style="'left: '+footLineGap+'px;width: calc(100vw - '+footLineGap+'px)'"
      class="bottom"
    >
      <div class="left-container">
        <div @click="selectAll" :class="{selectBtn: true,on: isSelectAll}"></div>
        <div @click="selectAll" class="selectWord">
          全选
          <span>（已选择{{selectListNum}}个素材）</span>
        </div>
        <div class="btn-container">
          <div v-click-outside="closeBottomBtn">
            <span @click="showBottomBtn = !showBottomBtn">创建</span>
            <ul v-show="showBottomBtn">
              <li
                v-show="$store.state.create.material"
                @click="navigateMaterial('material');showBottomBtn = false"
              >
                <span>上传线索</span>
              </li>
              <li
                v-show="$store.state.create.report"
                @click="navigateMaterial('report');showBottomBtn = false"
              >
                <span>创建报道</span>
              </li>
              <li
                v-show="$store.state.create.publish"
                @click="navigateMaterial('publish');showBottomBtn = false"
              >
                <span>创建发布</span>
              </li>
              <li
                v-show="$store.state.create.new_media"
                @click="navigateMaterial('new_media');showBottomBtn = false"
              >
                <span>新媒体发布</span>
              </li>
            </ul>
          </div>
          <div v-show="$store.state.quickEdit" @click="useDetail">选用</div>
          <div v-show="$store.state.has_stream_send" @click="mediaSend">归档</div>
          <div v-show="path != 'index'">删除</div>
        </div>
      </div>
      <div class="right-container">
        <p @click="cancelAll">取消选择</p>
      </div>
    </div>
  </div>
</template>

<script>
// 传入的
import common from '@common/common';
import { apis } from '@common/config';
import resourceHandles from '@components/resourceHandles';
import empty from '@components/empty';
import pushBox from '@components/pushBox';
import checkers from '@components/checkers';
import globalFilter from '@components/globalFilter';
import materialList from '@components/materialList';
import clueList from '@components/clueList/clueList';
import noMore from '@components/noMore';
import pages from '@components/pages';
import DatePicker from 'vue2-datepicker';
import skeleton from '@components/skeleton';
import store from '@common/store';
import vClickOutside from 'v-click-outside';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  name: 'index',
  components: {
    resourceHandles,
    empty,
    pushBox,
    checkers,
    globalFilter,
    materialList,
    noMore,
    pages,
    clueList,
    DatePicker,
    skeleton,
  },
  data() {
    return {
      type: 'myTool',
      yesterdayNum: 0,
      showBottomBtn: false,
      selectList: [],
      path: '',
      selectListNum: 0,
      footLineGap: 230,
      bottomWidth: '1105px',
      showAllBox: false,
      twoHeight: 0,
      showToggle: false,
      waiting: true,
      scrollInternal: null,
      scrollWay: 'left',
      filterTypeList: ['全部', '图片', '视频', '音频'],
      start: '',
      end: '',
      filterType: 0,
      datePicker: '',
      boxWidth: 0,
      boxHeight: 0,
      thingWidth: 0,
      thingHeight: 0,
      showFilter: true,
      page: {
        pageCount: 0,
        pageSize: 20,
        pageIndex: 1,
        total: 0,
      },
      searchOptions: {},
      pageType: 'file',
      tabList: [],
      mList: [],
      clueList: [],
      fillList: [],
      dealIndex: 0,
      dealList: [],
      cardList: {
        latestNotices: {
          list: [],
        },
        appraisal: {
          is_show: false,
        },
        bsEdit: {
          is_show: false,
        },
        ai_wisdom_strategy: {
          is_show: false,
          has_new: false,
        },
        dataCenter: {
          is_show: false,
        },
        live: {
          is_show: false,
        },
        meiZi: {
          is_show: false,
        },
        proposal: {
          is_show: false,
        },
        seriesSingle: {
          is_show: false,
        },
        streamMedia: {
          is_show: false,
        },
        anchor: {
          is_show: false,
        },
        videoStudio: {
          is_show: false,
        },
        voiceRec: {
          is_show: false,
        },
        voiceEditList: {
          is_show: false,
        },
        gsportsSubscribeFilter: {
          is_show: false,
        },
        voiceComposeList: {
          is_show: false,
        },
        nanometer_consulting: {
          is_show: false,
        },
        gsports_program_series: {
          is_show: false,
        },
        intelligentWriting: {
          is_show: false,
        },
        client: {
          is_show: false,
          has_new: false,
        },
        themeTrack: {
          is_show: false,
          has_new: false,
        },
        mediaBoard: {
          is_show: false,
          has_new: false,
        },
        knewsdata: {
          is_show: false,
          has_new: false,
        },
        tvbaopian: {
          is_show: false,
          has_new: false,
        },
        spread: {
          is_show: false,
          has_new: false,
        },
        track: {
          is_show: false,
          has_new: false,
        },
        timeVideo: {
          is_show: false,
          has_new: false,
        },
        dataCenterPublishCalculate: {
          is_show: false,
          has_new: false,
        },
        gsportsData: {
          is_show: false,
          has_new: false,
        },
        fiveViewData: {
          is_show: false,
          has_new: false,
        },
        gsportsOperateData: {
          is_show: false,
          has_new: false,
        },
        drowAnalize: {
          is_show: false,
          has_new: false,
        },
        productAnalize: {
          is_show: false,
          has_new: false,
        },
        aigcEdit: {
          is_show: false,
          has_new: false,
        },
        newsCascadeMonad: {
          is_show: false,
          has_new: false,
        },
        dailyreport: {
          is_show: false,
        },
        thirdSpread: {
          is_show: false,
          has_new: false,
        },
        interplay: {
          is_show: false,
          has_new: false,
        },
        xwmzRedirect: {
          is_show: false,
        },
      },
      cardNum: 2,
      cardNum1: 0,
      todos: [
        {
          type: 1,
          title: '采访',
          count: 0,
          able: false,
          name: 'myInterviews',
          path: '/myInterviews',
          params: {
            status: 2,
          },
        },
        {
          type: 2,
          title: '线索',
          count: 0,
          able: false,
          name: 'myClue',
          path: '/myClue',
          params: {
            status: 0,
          },
        },
        {
          type: 3,
          title: '报道',
          count: 0,
          able: false,
          name: 'myreport',
          path: '/myreport',
        },
        {
          type: 4,
          title: '采访审核',
          count: 0,
          able: false,
          name: 'checkInterviews',
          path: '/checkInterviews',
        },
        {
          type: 5,
          title: '资源分配',
          count: 0,
          able: false,
          name: 'resources',
          path: '/resources',
        },
        {
          type: 6,
          title: '报道审核',
          count: 0,
          able: false,
          name: 'examineReport',
          path: '/examineReport',
        },
        {
          type: 7,
          title: '发布',
          count: 0,
          able: false,
          name: 'myPublish',
          path: '/myPublish',
        },
        {
          type: 8,
          title: '发布审核',
          count: 0,
          able: false,
          name: 'publishAudit',
          path: '/publishAudit',
        },
      ],
      latestNoticesIndex: 0,
      show_list: true, //是否有权限全站检索,
      loading: true,
      isPendPage: true,
      isSelectAll: false,
    };
  },
  watch: {
    type(to) {
      this.calculateWidth();
      this.showAllBox = false;
      this.calThings();
    },
    setflashPic1: {
      handler(e) {
        console.log(e);
        if (e) {
          this.page.pageIndex = 1;
          this.getList();
        }
      },
      immediate: true,
      deep: true,
    },
    footLineGap(to) {
      this.bottomWidth = this.$refs.content.getBoundingClientRect().width + 'px';
    },
    pageType(to) {
      this.selectList = [];
      this.selectListNum = 0;
      this.$set(this.page, 'pageSize', to == 'file' ? 20 : 10);
      this.$set(this.page, 'pageIndex', 1);
      this.pageType = to;
      this.filterType = 0;
      this.start = '';
      this.end = '';
      this.datePicker = '';
      this.getList();
    },
    filterType() {
      this.$set(this.page, 'pageIndex', 1);
      this.getList();
    },
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1;
        this.start = common.stampToTime(n[0]);
        this.end = this.getDayEnd(n[1]);
        this.getList();
      },
    },
    '$store.state.selectList': function (e) {
      this.selectList = e;
      this.selectListNum = e.length;
    },
    '$store.state.isSelectAll': function (e) {
      this.isSelectAll = e;
    },
    '$store.state.flashPic1': function (e) {
      this.page.pageIndex = 1;
      this.getList();
    },
  },
  computed: {
    empty() {
      let { pageType, mList, clueList } = this;
      let empty = '';
      if (pageType == 'file') {
        if (!mList || !mList.length) {
          empty = '素材';
        }
      } else {
        if (!clueList || !clueList.length) {
          empty = '线索';
        }
      }
      return empty;
    },
    setflashPic1() {
      return this.$store.state.flashPic1;
    },
  },
  methods: {
    mediaSend() {
      let id = [];
      this.selectList.forEach((el) => {
        id.push(el.id);
      });
      id = id.join(',');
      let info = {
        subject_type: 10,
        subject_id: id,
      };
      common.myFetch(apis.streamMediaSend, info).then((r) => {
        if (r) {
          this.$toast(r);
        }
      });
    },
    navigateToAnchor() {
      common.jump(`/anchor`, true);
    },
    navigateToyb() {
      common.jumpOut(this.cardList.videoStudio.host_url + 'uid=' + common.getUid() + '&unid=' + common.getUnid(), true);
    },
    closeBottomBtn() {
      this.showBottomBtn = false;
    },
    async navigateMaterial(type) {
      let arr = [];
      let id = '';
      this.selectList.forEach((el) => {
        arr.push(el.id);
      });
      if (arr.length > 0) {
        id = arr.join(',');
        if (type === 'interview') {
          common.jump('/newInterview', true);
        } else if (type === 'material') {
          let info = {
            id: id,
            push_to: type,
            type: 0,
          };
          common.myFetch(apis.File_filepush, info).then((r) => {
            if (r) {
              common.jump(`/creatClue?t=0&d=${r.id}`, true);
            }
          });
        } else if (type === 'report') {
          const typeName = await this.$pageType();
          if (!typeName) return;
          let info = {
            id: id,
            push_to: type,
            type: typeName,
          };
          common.myFetch(apis.File_filepush, info).then((r) => {
            if (r) {
              common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === 'publish') {
          const typeName = await this.$pageType('publish');
          if (!typeName) return;
          let info = {
            id: id,
            push_to: type,
            type: typeName,
          };
          common.myFetch(apis.File_filepush, info).then((r) => {
            if (r) {
              common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === 'new_media') {
          const typeName = await this.$MediaPlatform();
          if (!typeName) return;
          let info = {
            file_ids: id,
            subject_type: 5,
            subject_id: typeName,
          };
          common.myFetch(apis.File_bind, info).then((r) => {
            if (r) {
              common.jump(`/createMediaPublish?d=${typeName}`, true);
            }
          });
        }
      }
    },
    useDetail() {
      let id = [];
      this.selectList.forEach((el) => {
        id.push(el.id);
      });
      id = id.join(',');
      let data = {
        file_ids: id,
      };

      common.myFetch(apis.File_addquickfile, data).then((res) => {
        if (res) {
          this.$toast('已成功加入选用素材');
          store.commit('setQuickEditNum', res.quick_edit_num);
        }
      });
    },
    setIsSelectAll(e) {
      this.isSelectAll = e;
    },
    cancelAll() {
      this.isSelectAll = false;
      store.commit('setIsSelectAll', this.isSelectAll);
      store.commit('cancelSelect', new Date());
    },
    selectAll() {
      this.isSelectAll = !this.isSelectAll;
      store.commit('setIsSelectAll', this.isSelectAll);
    },
    setSelectList(e) {
      this.selectListNum = e.length;
    },
    cleanInterval() {
      clearInterval(this.scrollInternal);
      this.scrollInternal = null;
    },
    startInterval() {
      this.scrollInternal = setInterval(() => {
        this.autoScroll();
      }, 7000);
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return '';
      }

      const year = s.getFullYear();
      const month = common.doubleDigit(s.getMonth() + 1);
      const day = common.doubleDigit(s.getDate());

      return `${year}-${month}-${day} 23:59:59`;
    },
    goCloudEdit() {
      common.jumpOut('/cloudEdit');
      // this.$router.push({
      //   path: "/cloudEdit"
      // });
    },
    goAnnouce(i) {
      // 跳转公告详情
      this.$router.push({
        path: '/announcement',
        query: {
          d: i.id,
        },
      });
    },
    leftArrowClick() {
      if (this.latestNoticesIndex > 0) {
        this.latestNoticesIndex--;
      }
    },
    rightArrowClick() {
      if (this.latestNoticesIndex < this.cardList.latestNotices.list.length - 1) {
        this.latestNoticesIndex++;
      }
    },
    autoScroll() {
      if (this.scrollWay == 'left') {
        if (this.latestNoticesIndex < this.cardList.latestNotices.list.length - 1) {
          this.latestNoticesIndex++;
        } else {
          this.scrollWay = 'right';
          this.latestNoticesIndex--;
        }
      } else {
        if (this.latestNoticesIndex > 0) {
          this.latestNoticesIndex--;
        } else {
          this.scrollWay = 'left';
          this.latestNoticesIndex++;
        }
      }
    },
    dealLeft() {
      if (this.dealIndex > 0) {
        this.dealIndex--;
      }
    },
    dealRight() {
      if (this.dealIndex < Math.abs(Math.ceil(this.dealList.length / 3 - 1))) {
        this.dealIndex++;
      }
    },
    goDynamicRoute(i) {
      // 跳转动态路由页面
      if (i.hasOwnProperty('able') && !i.able) return;

      if (i.count != 0) {
        this.$router.push({
          path: `/${i.menu_type}/${i.idstring}`,
        });
      }
    },
    matchTodos(todos) {
      // 匹配待处理数据
      this.todos.forEach((i) => {
        switch (i.type) {
          case 1:
            i.count = todos.interview.num;
            i.able = todos.interview.is_show;
            i.search = todos.interview.has_search - 0 === 1;
            i.idstring = todos.interview.idstring;
            i.menu_type = todos.interview.menu_type;
            break;

          case 2:
            i.count = todos.material.num;
            i.able = todos.material.is_show;
            i.search = todos.material.has_search - 0 === 1;
            i.idstring = todos.material.idstring;
            i.menu_type = todos.material.menu_type;
            break;

          case 3:
            i.count = todos.report.num;
            i.able = todos.report.is_show;
            i.search = todos.report.has_search - 0 === 1;
            i.idstring = todos.report.idstring;
            i.menu_type = todos.report.menu_type;
            break;

          case 4:
            i.count = todos.interviewAudit.num;
            i.able = todos.interviewAudit.is_show;
            i.search = todos.interviewAudit.has_search - 0 === 1;
            i.idstring = todos.interviewAudit.idstring;
            i.menu_type = todos.interviewAudit.menu_type;
            break;

          case 5:
            i.count = todos.resourceAllocation.num;
            i.able = todos.resourceAllocation.is_show;
            i.search = todos.resourceAllocation.has_search - 0 === 1;
            i.idstring = todos.resourceAllocation.idstring;
            i.menu_type = todos.resourceAllocation.menu_type;
            break;

          case 6:
            i.count = todos.reportDistribution.num;
            i.able = todos.reportDistribution.is_show;
            i.search = todos.reportDistribution.has_search - 0 === 1;
            i.idstring = todos.reportDistribution.idstring;
            i.menu_type = todos.reportDistribution.menu_type;
            break;

          // 待添加7、8，发布的字段
          case 7:
            i.count = todos.publish.num;
            i.able = todos.publish.is_show;
            i.search = todos.publish.has_search - 0 === 1;
            i.idstring = todos.publish.idstring;
            i.menu_type = todos.publish.menu_type;
            break;

          case 8:
            i.count = todos.publishVerify.num;
            i.able = todos.publishVerify.is_show;
            i.search = todos.publishVerify.has_search - 0 === 1;
            i.idstring = todos.publishVerify.idstring;
            i.menu_type = todos.publishVerify.menu_type;
            break;

          default:
            i.count = 0;
        }
      });

      this.todos = this.todos.filter((el) => {
        return el.able;
      });

      this.dealList = this.todos;
    },
    navigate(menu_type, idstring) {
      common.jump('/' + menu_type + '/' + idstring, true);
    },
    async navigateTo(menu_type, admin_type) {
      if (admin_type) {
        common.jump('/' + menu_type + '?admin_type=' + admin_type, true);
      }
      // 如果是智能写稿 要去新建发布
      else if (menu_type == 'intelligentWriting') {
        const typeName = await this.$pageType('publish');
        if (!typeName) return;
        common.jump(`/createPublish?t=${typeName}`, true);
      }else if (menu_type == 'nanometer_consulting') {
        common.jump('/sportsUp', true);
      }else if (menu_type == 'gsports_program_series') {
        common.jump('/sportSeriesList', true);
      } else {
        common.jump('/' + menu_type, true);
      }
    },
    getCard() {
      const info = {};

      // 获取首页数据
      common.myFetch(apis.Index_card, info).then((data) => {
        if (data) {
          let index = 0;
          let index1 = 0;
          for (const key in data) {
            if (
              data[key].is_show &&
              (key == 'bsEdit' ||
                key == 'ai_wisdom_strategy' ||
                key == 'meiZi' ||
                key == 'streamMedia' ||
                key == 'seriesSingle' ||
                key == 'live' ||
                key == 'dataCenter' ||
                key == 'appraisal' ||
                key == 'proposal' ||
                key == 'anchor' ||
                key == 'videoStudio' ||
                key == 'timeVideo' ||
                key == 'voiceRec' ||
                key == 'voiceEditList' ||
                key == 'voiceComposeList' ||
                key == 'nanometer_consulting' ||
                key == 'gsports_program_series' ||
                key == 'intelligentWriting' ||
                key == 'gsportsSubscribeFilter' ||
                key == 'aigcEdit' ||
                key == 'newsCascadeMonad' ||
                key == 'interplay' || 
                key == 'xwmzRedirect')
            ) {
              index++;
            }
          }
          for (const key in data) {
            if (
              data[key].is_show &&
              (key == 'knewsdata' ||
                key == 'tvbaopian' ||
                key == 'spread' ||
                key == 'track' ||
                key == 'dataCenterPublishCalculate' ||
                key == 'drowAnalize' ||
                key == 'productAnalize' ||
                key == 'gsportsData' ||
                key == 'fiveViewData' ||
                key == 'gsportsOperateData' ||
                key == 'thirdSpread' ||
                key == 'dailyreport')
            ) {
              index1++;
            }
          }
          // console.log(data)
          this.cardNum = index + 2;
          this.cardNum1 = index1;
          this.cardList = Object.assign({}, this.cardList, data);

          data.pendPage.forEach((el, key) => {
            if (el && this.isPendPage) {
              this.isPendPage = false;
              this.dealIndex = key;
            }
          });
          // console.log(this.cardList)
          // console.log(this.dealIndex)
          this.matchTodos(data.pendings);
          this.$nextTick(() => {
            this.calculateWidth();
            this.scrollInternal = setInterval(() => {
              this.autoScroll();
            }, 7000);
          });
        }
      });
    },
    getList() {
      this.waiting = true;
      let has_file = -1;
      if (this.filterType == 0) {
        has_file = -1;
      } else {
        has_file = this.filterType;
      }
      let data = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: this.pageType,
        key_words: '',
        search_option: '',
        start: this.start,
        end: this.end,
        has_file: has_file,
      };
      this.loading = true;
      Object.assign(data, this.searchOptions);
      common.myFetch(apis.Index_search, data).then((res) => {
        this.loading = false;
        if (res) {
          this.$store.commit('setSelectList', []);
          this.yesterdayNum = res.yesterdayNum;
          this.tabList = res.params.tab.option.list;
          if (this.tabList.length > 0 && this.pageType == 'file') {
            this.pageType = res.params.tab.option.list[0].key;
          }
          res.list.forEach((el) => {
            el.isSelected = false;
            el.isOn = false;
            el.showMenu = false;
            el.showLeft = false;
            el.showPushBtns = false;
            el.showThreePoint = false;
          });
          this.pageType == 'file' ? (this.mList = res.list) : (this.clueList = res.list);
          this.show_list = res.show_list;
          this.$set(this.page, 'pageCount', common.calculatePage(res.page.row_count - 0, this.page.pageSize));
          this.$set(this.page, 'total', res.page.row_count - 0);
          this.generateSearchs(res.params.top_search.option.list);
          this.$nextTick(() => {
            this.waiting = false;
          });
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected,
        };
      });

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o);
        },
        from: 'index',
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      if (this.$refs.globalFilter) {
        this.$refs.globalFilter.getData(data);
      }
      // this.$emit('filterData', data)
    },
    navigateToMZ() {
      let info = {};
      common.myFetch(apis.Usr_getlogintoken, info).then((r) => {
        console.log(r);
        if (r) {
          common.jumpOut(r.host + 'middle.html#/' + r.login_token);
          // this.$toast("修改成功");
        }
      });
    },
    navToThird(type) {
      let info = {
        type: type,
      };
      common.myFetch(apis.getDataInfo, info).then((r) => {
        if (r) {
          common.jumpOut(r.host);
          // this.$toast("修改成功");
        }
      });
    },
    navToThirdspread(type) {
      let info = {
        type: type,
      };
      common.myFetch(apis.thirdspread, info).then((r) => {
        if (r) {
          common.jumpOut(r.host);
          // this.$toast("修改成功");
        }
      });
    },
    navToThirdSport(type) {
      common.jump('/sportDataCenter?type=' + type, true);
    },
    navigateToPublic() {
      common.jump('/publicLibrary/public', false);
    },
    navigateToStream() {
      common.jump('/streamMedia', true);
    },
    navigateToDailyReport() {
      common.jump('/dailyReport', true);
    },

    navigateToOut(url) {
      common.jumpOut(url);
    },
    navigateToTab(url) {
      window.location.href = url;
    },
    calculateWidth() {
      console.log(this.type);
      let num = 0;
      if (this.type == 'myTool') {
        num = this.cardNum;
      } else if (this.type == 'analysis') {
        if (this.cardList.client.is_show || this.cardList.themeTrack.is_show || this.cardList.mediaBoard.is_show) num++;
      } else if (this.type == 'statistic') {
        if (
          this.cardList.knewsdata.is_show ||
          this.cardList.tvbaopian.is_show ||
          this.cardList.spread.is_show ||
          this.cardList.track.is_show ||
          this.cardList.dataCenterPublishCalculate.is_show ||
          this.cardList.drowAnalize.is_show ||
          this.cardList.productAnalize.is_show ||
          this.cardList.gsportsData.is_show ||
          this.cardList.fiveViewData.is_show ||
          this.cardList.gsportsOperateData.is_show ||
          this.cardList.thirdSpread.is_show
        )
          num = this.cardNum1;
      }
      console.log(num);
      const list = this.$refs.tabList;
      if (!list || !list.getBoundingClientRect()) return;
      const listWidth = list.getBoundingClientRect().width;
      let fillWidth = 0;
      const itemWidth = 251; // item dom宽度
      const itemGap = 20; //item 边距
      const listGap = 0; // list左右边距
      const countsPerPage = num || 20; //每页的item数量
      const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
      const itemRatio = 108 / 251;
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
      const itemHeightNow = itemWidthNow * itemRatio;
      let arr = [];

      for (let index = 0; index < countsPerRow - countsLastLine; index++) {
        arr.push(index);
      }

      this.fillList = arr;

      fillWidth = countsPerRow === countsLastLine ? 0 : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);
      console.log(fillWidth);
      this.boxWidth = fillWidth;
      this.boxHeight = itemHeightNow;
      this.$nextTick(() => {
        this.calThings();
        // console.log(calc(100vw - 230px);)
        this.bottomWidth = this.$refs.content.getBoundingClientRect().width + 'px';
      });
    },
    calThings() {
      const ting = this.$refs.tingsContent;
      if (!ting || !ting.getBoundingClientRect()) return;
      this.thingWidth = ting.getBoundingClientRect().width / 3;
      // console.log(ting.getBoundingClientRect().width / 3,ting.getBoundingClientRect().width)
      this.thingHeight = (this.thingWidth * 54) / 63;

      this.$nextTick(() => {
        let twoHeight = Number((this.boxHeight * 2 + 40).toFixed(2));
        let nowHeight = Number(this.$refs.tabList.getBoundingClientRect().height.toFixed(2));
        if (nowHeight > twoHeight && !this.showAllBox) {
          this.showToggle = true;
          this.twoHeight = twoHeight + 'px';
        } else {
          this.twoHeight = 'auto';
        }
      });
    },
    addCalcEvent() {
      window.addEventListener('resize', () => {
        this.calculateWidth();
      });
    },
    toggleAll() {
      if (this.showAllBox) {
        this.twoHeight = 'auto';
      } else {
        let twoHeight = Number((this.boxHeight * 2 + 40).toFixed(2));
        this.twoHeight = twoHeight + 'px';
      }
    },
    navigateToMZNews() {
      // common.jumpOut('https://news-dev.netapitest.com');
      common.jumpOut('https://news-test.netapitest.com');
    },
  },
  beforeDestroy() {
    clearInterval(this.scrollInternal);
    this.scrollInternal = null;
    this.$store.commit('setSelectList', []);
    this.$AiMessage(true);
  },
  mounted() {
    const path = this.$route.path.split('/')[1];
    this.path = path;
    this.selectListNum = this.$store.state.selectList.length;
    this.calculateWidth();
    this.getCard();
    this.addCalcEvent();
    this.getList();
    this.$AiMessage();
  },
};
</script>
<style src="@assets/css/index1.less" lang="less" scoped>
</style>
